(function () {
  if (window.__idmCollectionPageAssetLoaded) return;
  window.__idmCollectionPageAssetLoaded = true;

  var ROOT_SELECTOR = '[data-collection-page]';
  var TEXT_MODAL_SEL = '.modal-sizechart';
  var VIDEO_MODAL_SEL = '.modal-sizechart2';
  var VIDEO_BODY_OPEN_CLASS = 'fade-sizechart2';

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function getRoot(node) {
    return node && node.closest ? node.closest(ROOT_SELECTOR) : null;
  }

  function getPrimaryRoot() {
    return document.querySelector(ROOT_SELECTOR);
  }

  function isEnglish(root) {
    return !!(root && root.getAttribute('data-iso-short') === 'en');
  }

  function isVisible(el) {
    if (!el) return false;
    var s = getComputedStyle(el);
    return (
      (s.display !== 'none' && s.visibility !== 'hidden' && parseFloat(s.opacity || '1') > 0) ||
      el.classList.contains('open') ||
      el.getAttribute('aria-hidden') === 'false'
    );
  }

  function toggleReadMore(button, root) {
    if (!button) return;

    var panel = button.previousElementSibling;
    if (!panel) return;

    panel.classList.toggle('hide-product-content');

    var readMore = root ? (root.getAttribute('data-read-more-label') || '') : '';
    var readLess = root ? (root.getAttribute('data-read-less-label') || '') : '';
    var currentText = (button.textContent || '').trim();

    button.textContent = currentText === readMore ? readLess : readMore;
  }

  var stickyBooted = new WeakMap();

  function initStickyHeader(root) {
    if (!root || root.getAttribute('data-sticky-title') !== 'true' || stickyBooted.has(root)) return;

    var collectionBanner = $('#collection-banner', root);
    var collectionHeader = $('#collection-header', root);
    if (!collectionHeader) return;

    var ticking = false;
    var largeur = window.innerWidth;

    // 12/10/2026 — CLS : en devenant collante, la barre perd sa marge basse et, sur petit mobile, son titre passe de 2 lignes à 1
    // (141 → 64 px) : la grille remontait d'un coup de 67 px (RUM : 7 events en une semaine, 0,07-0,08 chacun, 320-360 px).
    // On garde la place dans le flux : marge basse de la barre = ce qu'elle a perdu (mesuré sans transition du titre), retirée
    // au retour à l'état normal → la grille ne bouge plus. Recalcul si la largeur change pendant que la barre est collante.
    // Marge posée en « important » : idm-product-perf.css impose margin-bottom:10px !important à la barre collante.
    // Mesures en coordonnées de la PAGE (pas de l'écran) : au rechargement en milieu de page, Chrome recale le défilement
    // (scroll anchoring) entre deux mesures et une mesure à l'écran donnait 0.
    function basculer(collant) {
      var suivant = collectionHeader.nextElementSibling;
      var titre = $('.collection-title', collectionHeader);
      var posDoc = function () { return suivant.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0); };
      if (titre) titre.style.transition = 'none';
      collectionHeader.style.removeProperty('margin-bottom');
      collectionHeader.classList.remove('collection-scroll-filters');
      if (collant) {
        var y0 = suivant ? posDoc() : 0;
        collectionHeader.classList.add('collection-scroll-filters');
        if (suivant) {
          var perte = y0 - posDoc();
          if (perte > 0.5) {
            var base = parseFloat(getComputedStyle(collectionHeader).marginBottom) || 0;
            collectionHeader.style.setProperty('margin-bottom', (base + perte) + 'px', 'important');
            var reste = y0 - posDoc();
            if (Math.abs(reste) > 0.5) collectionHeader.style.setProperty('margin-bottom', (base + perte + reste) + 'px', 'important');
          }
        }
      }
      if (titre) { void titre.offsetHeight; titre.style.transition = ''; }
    }

    function updateStickyState() {
      ticking = false;
      var bannerHeight = collectionBanner ? collectionBanner.offsetHeight : 0;
      var threshold = collectionHeader.getBoundingClientRect().top + bannerHeight;
      var collant = window.pageYOffset >= threshold;
      var largeurChangee = window.innerWidth !== largeur;
      largeur = window.innerWidth;
      if (collant !== collectionHeader.classList.contains('collection-scroll-filters') || (collant && largeurChangee)) basculer(collant);
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateStickyState);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('load', requestUpdate, { once: true });

    stickyBooted.set(root, true);
    updateStickyState();
  }

  var TextModal = (function () {
    var booted = false;
    var observer = null;

    function attachModalObserver(modal) {
      if (!modal || modal.__hasModalObserver) return;
      modal.__hasModalObserver = true;

      var prevOpen = isVisible(modal);
      var obs = new MutationObserver(function () {
        var nowOpen = isVisible(modal);

        if (nowOpen && !prevOpen) {
          open(modal, false);
        } else if (!nowOpen && prevOpen) {
          close(modal, false);
        }

        prevOpen = nowOpen;
      });

      obs.observe(modal, {
        attributes: true,
        attributeFilter: ['class', 'style', 'aria-hidden']
      });
    }

    function boot() {
      if (booted) return;
      if (!$(TEXT_MODAL_SEL) && !$('.product-size-guide')) return;

      booted = true;
      $all(TEXT_MODAL_SEL).forEach(attachModalObserver);

      observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
            if (!node || node.nodeType !== 1) return;

            if (node.matches && node.matches(TEXT_MODAL_SEL)) {
              attachModalObserver(node);
            } else {
              $all(TEXT_MODAL_SEL, node).forEach(attachModalObserver);
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }

    function ensure() {
      boot();
      return $(TEXT_MODAL_SEL);
    }

    function open(modal, fromPopstate) {
      if (!modal) return;

      modal.style.setProperty('display', 'flex', 'important');
      modal.style.setProperty('visibility', 'visible', 'important');
      modal.style.setProperty('opacity', '1', 'important');
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('open');
      modal.dataset.historyPushed = modal.dataset.historyPushed || '0';

      if (!fromPopstate && modal.dataset.historyPushed !== '1') {
        try {
          history.pushState({ modal: 'text' }, '', location.href);
        } catch (e) {}
        modal.dataset.historyPushed = '1';
      }
    }

    function close(modal, fromPopstate) {
      if (!modal) return;

      modal.style.setProperty('display', 'none', 'important');
      modal.style.setProperty('visibility', 'hidden', 'important');
      modal.style.setProperty('opacity', '0', 'important');
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('open');

      if (!fromPopstate && modal.dataset.historyPushed === '1') {
        modal.dataset.historyPushed = '0';
        try {
          history.back();
        } catch (e) {}
      } else if (fromPopstate) {
        modal.dataset.historyPushed = '0';
      }
    }

    function getOpen() {
      var modal = $(TEXT_MODAL_SEL);
      return modal && isVisible(modal) ? modal : null;
    }

    return {
      boot: boot,
      ensure: ensure,
      open: open,
      close: close,
      getOpen: getOpen
    };
  })();







var VideoModal = (function () {
  var IFRAME_SELECTOR =
    'iframe.js-deferred-youtube,' +
    'iframe[data-src*="youtube.com/embed"],' +
    'iframe[data-src*="youtube-nocookie.com/embed"],' +
    'iframe[src*="youtube.com/embed"],' +
    'iframe[src*="youtube-nocookie.com/embed"]';

  var state = {
    historyPushed: false,
    pendingPlay: false,
    booted: false,
    modals: [],
    modal: null,
    extraModals: [],
    iframe: null,
    container: null,
    player: null,
    playerReady: false,
    resumeSeconds: 0,
    needsRebuild: false,
    apiRequested: false,
    apiCallbacks: [],
    originalIframeHTML: '',
    originalIframeId: '',
    openScrollY: 0,
    previousScrollRestoration: null,
    deferredStopTimer: null,
    deferredStopRaf: 0
  };

  function isIOSSafari() {
    var ua = window.navigator.userAgent || '';
    var isIOS = /iP(ad|hone|od)/i.test(ua);
    var isWebKit = /WebKit/i.test(ua);
    var isOtherIOSBrowser = /CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua);
    return isIOS && isWebKit && !isOtherIOSBrowser;
  }

  function getScrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  function rememberScrollRestoration() {
    if (!('scrollRestoration' in history)) return;
    if (state.previousScrollRestoration === null) {
      try {
        state.previousScrollRestoration = history.scrollRestoration;
      } catch (e) {
        state.previousScrollRestoration = 'auto';
      }
    }
    try {
      history.scrollRestoration = 'manual';
    } catch (e) {}
  }

  function restoreScrollRestorationLater() {
    if (!('scrollRestoration' in history)) return;

    var prev = state.previousScrollRestoration === null ? 'auto' : state.previousScrollRestoration;

    setTimeout(function () {
      try {
        history.scrollRestoration = prev;
      } catch (e) {}
    }, 350);

    state.previousScrollRestoration = null;
  }

  function scheduleScrollRestore() {
    var y = state.openScrollY;
    if (typeof y !== 'number' || !isFinite(y)) {
      restoreScrollRestorationLater();
      return;
    }

    var root = document.documentElement;
    var prevBehavior = root.style.scrollBehavior;

    root.style.scrollBehavior = 'auto';

    function restore() {
      try {
        window.scrollTo(0, y);
      } catch (e) {}
    }

    restore();
    requestAnimationFrame(restore);
    setTimeout(restore, 40);
    setTimeout(restore, 120);
    setTimeout(function () {
      restore();
      root.style.scrollBehavior = prevBehavior || '';
      restoreScrollRestorationLater();
    }, 320);
  }

  function clearDeferredStop() {
    if (state.deferredStopTimer) {
      clearTimeout(state.deferredStopTimer);
      state.deferredStopTimer = null;
    }
    if (state.deferredStopRaf) {
      cancelAnimationFrame(state.deferredStopRaf);
      state.deferredStopRaf = 0;
    }
  }

  // 19/10/2026 (INP de la croix close-sizechart-bar2 des collections : 200 à 650 ms, Clarity) : son coupé et fenêtre masquée
  // pendant le toucher, démontage du lecteur YouTube APRÈS l'image suivante (même correction que les fiches).
  function couperLeSon() {
    if (state.playerReady && state.player && typeof state.player.pauseVideo === 'function') {
      try { state.player.pauseVideo(); } catch (e) {}
      return;
    }
    if (state.iframe && state.iframe.contentWindow) {
      try {
        state.iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
      } catch (e) {}
    }
  }

  function planifierArret() {
    clearDeferredStop();
    state.needsRebuild = true;
    state.deferredStopRaf = requestAnimationFrame(function () {
      state.deferredStopRaf = 0;
      state.deferredStopTimer = setTimeout(function () {
        state.deferredStopTimer = null;
        if (isOpen()) return;
        stopExtraModalsMedia();
        hardStopPrimaryPlayback();
      }, 0);
    });
  }

  function getModals() {
    return $all(VIDEO_MODAL_SEL);
  }

  function getIframeFromModal(modal) {
    return modal ? modal.querySelector(IFRAME_SELECTOR) : null;
  }

  function getModal() {
    refreshRefs();
    return state.modal;
  }

  function isOpen() {
    return document.body.classList.contains(VIDEO_BODY_OPEN_CLASS);
  }

  function refreshRefs() {
    state.modals = getModals();
    state.modal = state.modals.length ? state.modals[0] : null;
    state.extraModals = state.modals.length > 1 ? state.modals.slice(1) : [];

    state.iframe = getIframeFromModal(state.modal);
    state.container = state.iframe && state.iframe.parentNode
      ? state.iframe.parentNode
      : (state.modal ? state.modal.querySelector('.video-container') : null);

    if (state.iframe && !state.originalIframeHTML) {
      state.originalIframeHTML = state.iframe.outerHTML;
      state.originalIframeId = state.iframe.id || '';
    }
  }

  // 19/10/2026 : écritures seulement si la valeur change (règle « pas d'écriture à l'identique » : cette fonction tourne à chaque ouverture et
  // fermeture, et jusqu'à 6 fois de suite dans forceHideModalShellRepeated ; chaque écriture identique réveillait les observateurs de la page).
  function poserStyle(el, prop, val) {
    if (el.style.getPropertyValue(prop) !== val || el.style.getPropertyPriority(prop) !== 'important') el.style.setProperty(prop, val, 'important');
  }
  function oterStyle(el, prop) {
    if (el.style.getPropertyValue(prop) !== '') el.style.removeProperty(prop);
  }

  function syncModalVisibility(opened) {
  refreshRefs();

  state.modals.forEach(function (modal, index) {
    var show = !!opened && index === 0;
    var content = modal ? modal.querySelector('.modal-sizechart2-content') : null;

    if (modal.getAttribute('aria-hidden') !== (show ? 'false' : 'true')) modal.setAttribute('aria-hidden', show ? 'false' : 'true');

    if (show) {
      oterStyle(modal, 'display');
      oterStyle(modal, 'visibility');
      oterStyle(modal, 'opacity');
      oterStyle(modal, 'pointer-events');

      if (content) {
        oterStyle(content, 'visibility');
        oterStyle(content, 'opacity');
        oterStyle(content, 'pointer-events');
      }
    } else {
      poserStyle(modal, 'display', 'none');
      poserStyle(modal, 'visibility', 'hidden');
      poserStyle(modal, 'opacity', '0');
      poserStyle(modal, 'pointer-events', 'none');

      if (content) {
        poserStyle(content, 'visibility', 'hidden');
        poserStyle(content, 'opacity', '0');
        poserStyle(content, 'pointer-events', 'none');
      }
    }
  });
}

  function setParam(url, key, value) {
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set(key, value);
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function removeParam(url, key) {
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.delete(key);
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  // 19/10/2026 — même défaut et même correction que la fenêtre « Voir & écouter » des fiches (assets/idm-product-perf.js) :
  // l'ancien « contournement iOS » chargeait la vidéo par contentWindow.location.replace(src) SANS poser l'attribut src ; l'API YouTube
  // (www-widgetapi.js) calcule l'adresse de ses messages à partir de iframe.src → aucune poignée de main, onReady jamais reçu,
  // playVideo jamais envoyé, lecteur muet pour la page (Clarity : vidéo de l'encart lancée 0 fois sur 23 quand isIOSSafari() est
  // vrai, 94 à 100 % ailleurs). On pose TOUJOURS l'attribut src, pendant le toucher, sur un cadre neuf (voir open()).
  // Le cadre de l'encart vient du contenu de la page liée (popup-size-chart2.liquid lui ajoute loading="lazy") : chargement
  // différé = départ HORS du toucher. L'attribut est retiré avant de poser l'adresse, comme les vignettes YouTube (cadre sans lazy).
  function setIframeSrcSafely(iframe, src) {
    if (!iframe || !src) return false;

    var currentSrc = iframe.getAttribute('src') || '';
    if (currentSrc === src) return false;

    if (iframe.getAttribute('loading') === 'lazy') iframe.removeAttribute('loading');
    iframe.setAttribute('src', src);
    return false;
  }

  function getRawSrc() {
    if (!state.iframe) return '';
    return (
      state.iframe.getAttribute('data-src-original') ||
      state.iframe.getAttribute('data-src') ||
      state.iframe.getAttribute('src') ||
      ''
    );
  }

  function ensureIframeId() {
    if (!state.iframe) return '';
    if (!state.iframe.id) {
      state.iframe.id = state.originalIframeId || 'idm-sizechart2-video';
    }
    return state.iframe.id;
  }

  function buildPlayerSrc(autoplay) {
    var raw = getRawSrc();
    if (!raw) return '';

    var src = raw;
    src = setParam(src, 'enablejsapi', '1');
    src = setParam(src, 'playsinline', '1');
    src = setParam(src, 'origin', window.location.origin);
    src = setParam(src, 'rel', '0');
    src = setParam(src, 'autoplay', autoplay ? '1' : '0');

    if (state.resumeSeconds > 0) {
      src = setParam(src, 'start', String(Math.max(0, Math.floor(state.resumeSeconds))));
    } else {
      src = removeParam(src, 'start');
    }

    return src;
  }

  function loadYouTubeApi(callback) {
    if (window.YT && typeof window.YT.Player === 'function') {
      callback();
      return;
    }

    state.apiCallbacks.push(callback);

    if (state.apiRequested) return;
    state.apiRequested = true;

    var previousReady = window.onYouTubeIframeAPIReady;

    window.onYouTubeIframeAPIReady = function () {
      if (typeof previousReady === 'function') {
        try {
          previousReady();
        } catch (e) {}
      }

      var queue = state.apiCallbacks.slice(0);
      state.apiCallbacks = [];

      for (var i = 0; i < queue.length; i += 1) {
        try {
          queue[i]();
        } catch (e) {}
      }
    };

    var existingApi = document.querySelector(
      'script[src*="youtube.com/iframe_api"], script[src*="youtube.com/player_api"]'
    );

    if (existingApi) return;

    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';

    var firstScriptTag = document.getElementsByTagName('script')[0];
    if (firstScriptTag && firstScriptTag.parentNode) {
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    } else {
      document.head.appendChild(tag);
    }
  }

  // 19/10/2026 : vidéo vue jusqu'au bout → la réouverture repart du début (avant : start=<durée>, la vidéo ne repartait pas).
  function saveCurrentTime() {
    if (!state.playerReady || !state.player || typeof state.player.getCurrentTime !== 'function') return;

    try {
      var t = state.player.getCurrentTime();
      var etat = typeof state.player.getPlayerState === 'function' ? state.player.getPlayerState() : -1;
      var duree = typeof state.player.getDuration === 'function' ? state.player.getDuration() : 0;
      if (etat === 0 || (duree > 0 && t >= duree - 2)) {
        state.resumeSeconds = 0;
      } else if (typeof t === 'number' && isFinite(t) && t > 0) {
        state.resumeSeconds = t;
      }
    } catch (e) {}
  }

  function onPlayerReady() {
    state.playerReady = true;

    if (state.resumeSeconds > 0 && state.player && typeof state.player.seekTo === 'function') {
      try {
        state.player.seekTo(state.resumeSeconds, true);
      } catch (e) {}
    }

    if (state.pendingPlay && isOpen() && state.player && typeof state.player.playVideo === 'function') {
      try {
        state.player.playVideo();
      } catch (e) {}
    }

    state.pendingPlay = false;
  }

  function onPlayerStateChange(event) {
    if (!event) return;

    if (event.data === 0) {
      state.resumeSeconds = 0;
    }
  }

  function onAutoplayBlocked() {
    state.pendingPlay = false;
  }

  function stopIframePlayback(iframe, blankSrc) {
    if (!iframe) return;

    try {
      iframe.contentWindow.postMessage(JSON.stringify({
        event: 'command',
        func: 'pauseVideo',
        args: []
      }), '*');
    } catch (e) {}

    try {
      iframe.contentWindow.postMessage(JSON.stringify({
        event: 'command',
        func: 'stopVideo',
        args: []
      }), '*');
    } catch (e) {}

    if (blankSrc) {
      try {
        var currentSrc = iframe.getAttribute('src') || '';
        if (currentSrc && currentSrc !== 'about:blank' && !iframe.getAttribute('data-src-original')) {
          iframe.setAttribute('data-src-original', currentSrc);
        }
        iframe.setAttribute('src', 'about:blank');
      } catch (e) {}
    }
  }

  function stopExtraModalsMedia() {
    refreshRefs();

    state.extraModals.forEach(function (modal) {
      $all('iframe', modal).forEach(function (iframe) {
        stopIframePlayback(iframe, true);
      });
    });
  }

  function hardStopPrimaryPlayback() {
    refreshRefs();

    if (state.playerReady && state.player && typeof state.player.pauseVideo === 'function') {
      try {
        state.player.pauseVideo();
      } catch (e) {}
    }

    if (state.playerReady && state.player && typeof state.player.stopVideo === 'function') {
      try {
        state.player.stopVideo();
      } catch (e) {}
    }

    if (state.iframe) {
      stopIframePlayback(state.iframe, true);
    }

    if (state.player && typeof state.player.destroy === 'function') {
      try {
        state.player.destroy();
      } catch (e) {}
    }

    state.player = null;
    state.playerReady = false;
    state.needsRebuild = true;
  }

    function mountYouTubePlayer() {
    refreshRefs();
    if (!state.iframe) return;

    ensureIframeId();

    if (state.player && state.player.getIframe) {
      try {
        var currentIframe = state.player.getIframe();

        if (currentIframe && currentIframe.id === state.iframe.id) {
          if (state.playerReady && state.pendingPlay && isOpen()) {
            if (state.resumeSeconds > 0 && typeof state.player.seekTo === 'function') {
              try {
                state.player.seekTo(state.resumeSeconds, true);
              } catch (e) {}
            }

            if (typeof state.player.playVideo === 'function') {
              try {
                state.player.playVideo();
              } catch (e) {}
            }
          }

          state.pendingPlay = false;
          return;
        }
      } catch (e) {}
    }

    state.playerReady = false;

    try {
      state.player = new window.YT.Player(state.iframe.id, {
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
          onAutoplayBlocked: onAutoplayBlocked
        }
      });
    } catch (e) {}
  }

  function createPlayerOnCurrentIframe() {
    clearDeferredStop();
    refreshRefs();
    if (!state.iframe) return;

    ensureIframeId();

    var desiredSrc = buildPlayerSrc(state.pendingPlay && isOpen());
    var usedIOSFirstLoadWorkaround = false;

    if (desiredSrc) {
      usedIOSFirstLoadWorkaround = setIframeSrcSafely(state.iframe, desiredSrc);
    }

    loadYouTubeApi(function () {
      refreshRefs();
      if (!state.iframe) return;

      ensureIframeId();

      if (usedIOSFirstLoadWorkaround) {
        var iframe = state.iframe;
        var done = false;

        function bootAfterIframeLoad() {
          if (done) return;
          done = true;

          try {
            iframe.removeEventListener('load', bootAfterIframeLoad);
          } catch (e) {}

          mountYouTubePlayer();
        }

        iframe.addEventListener('load', bootAfterIframeLoad);

        setTimeout(function () {
          bootAfterIframeLoad();
        }, 350);

        return;
      }

      mountYouTubePlayer();
    });
  }

  function rebuildPrimaryIframe() {
    clearDeferredStop();
    refreshRefs();

    if (!state.modal || !state.originalIframeHTML) {
      state.needsRebuild = false;
      createPlayerOnCurrentIframe();
      return;
    }

    var container = state.container || state.modal.querySelector('.video-container');
    if (!container) {
      state.needsRebuild = false;
      createPlayerOnCurrentIframe();
      return;
    }

    if (state.player && typeof state.player.destroy === 'function') {
      try {
        state.player.destroy();
      } catch (e) {}
    }

    state.player = null;
    state.playerReady = false;

    container.innerHTML = state.originalIframeHTML;
    refreshRefs();

    if (!state.iframe) return;

    ensureIframeId();
    state.needsRebuild = false;
    createPlayerOnCurrentIframe();
  }

  function hideModalShell() {
  if (document.body.classList.contains(VIDEO_BODY_OPEN_CLASS)) document.body.classList.remove(VIDEO_BODY_OPEN_CLASS);
  syncModalVisibility(false);
}

function forceHideModalShellRepeated() {
  hideModalShell();

  requestAnimationFrame(function () {
    hideModalShell();

    requestAnimationFrame(function () {
      hideModalShell();
    });
  });

  setTimeout(hideModalShell, 0);
  setTimeout(hideModalShell, 80);
  setTimeout(hideModalShell, 180);
}

  function boot() {
    if (state.booted) return;
    if (!getModals().length && !$('.product-size-guide2')) return;

    state.booted = true;
    refreshRefs();
    syncModalVisibility(false);
    stopExtraModalsMedia();

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) {
        e.preventDefault();
        close(true, false);
      }
    }, true);
  }

  function ensure() {
    boot();
    refreshRefs();
    return state.modal;
  }

  function open(pushInHistory) {
    ensure();
    if (!state.modal) return;

    clearDeferredStop();
    syncModalVisibility(true);
    stopExtraModalsMedia();

    if (!isOpen()) {
      state.openScrollY = getScrollY();
      rememberScrollRestoration();

      document.body.classList.add(VIDEO_BODY_OPEN_CLASS);

      if (pushInHistory && !state.historyPushed) {
        try {
          history.pushState({ sizechart2Modal: true }, '', window.location.href);
          state.historyPushed = true;
        } catch (e) {}
      }
    }

    state.pendingPlay = true;

    // 19/10/2026 : 1re ouverture comprise, un cadre NEUF dont l'adresse est posée dans la même tâche que sa création (sinon Safari
    // ajoute une entrée à l'historique : retour à toucher deux fois pour quitter la page).
    var srcActuelle = state.iframe ? (state.iframe.getAttribute('src') || '') : '';
    if (state.needsRebuild || !srcActuelle || srcActuelle === 'about:blank') {
      rebuildPrimaryIframe();
      return;
    }

    createPlayerOnCurrentIframe();
  }

  function close(goBackInHistory, fromPopstate) {
    refreshRefs();
    if (!state.modals.length) return;

    if (!isOpen()) {
      if (!goBackInHistory) {
        state.historyPushed = false;
      }
      syncModalVisibility(false);
      stopExtraModalsMedia();

      if (isIOSSafari()) {
        scheduleScrollRestore();
      } else {
        restoreScrollRestorationLater();
      }
      return;
    }

    saveCurrentTime();
    state.pendingPlay = false;

    if (fromPopstate && isIOSSafari()) {
  stopExtraModalsMedia();
  forceHideModalShellRepeated();
  state.historyPushed = false;

  scheduleScrollRestore();

  clearDeferredStop();
  state.deferredStopTimer = setTimeout(function () {
    hardStopPrimaryPlayback();
    forceHideModalShellRepeated();
    state.deferredStopTimer = null;
  }, 180);

  return;
}

    // 19/10/2026 : son coupé et fenêtre masquée pendant le toucher ; démontage du lecteur après l'image suivante (planifierArret).
    couperLeSon();
    hideModalShell();
    planifierArret();

    if (goBackInHistory) {
      if (state.historyPushed) {
        state.historyPushed = false;
        try {
          history.back();
        } catch (e) {}
      }
    } else {
      state.historyPushed = false;
    }

    if (isIOSSafari()) {
      scheduleScrollRestore();
    } else {
      restoreScrollRestorationLater();
    }
  }

  return {
    boot: boot,
    ensure: ensure,
    open: open,
    close: close,
    isOpen: isOpen,
    getModal: getModal
  };
})();

  var AvisModal = (function () {
    var MODAL_SEL = '#idm-avis-modal';
    var BODY_CLASS = 'fade-sizechart3';

    function getModal() {
      return document.querySelector(MODAL_SEL);
    }

    function moveToBody(modal) {
      if (!modal || modal.parentNode === document.body) return;
      var old = document.querySelectorAll(MODAL_SEL);
      for (var i = 0; i < old.length; i++) {
        if (old[i] !== modal && old[i].parentNode === document.body) old[i].parentNode.removeChild(old[i]);
      }
      document.body.appendChild(modal);
    }

    function isOpen() {
      var modal = getModal();
      return !!(modal && modal.classList.contains('open'));
    }

    function loadContent(modal) {
      if (!modal || modal.dataset.idmLoaded === '1') return;
      var tpl = modal.querySelector('template.idm-avis-tpl');
      var box = modal.querySelector('.idm-avis-contenu');
      if (!tpl || !box || !tpl.content) return;
      modal.dataset.idmLoaded = '1';
      box.appendChild(tpl.content.cloneNode(true));
      try {
        if (window.Shapo && typeof window.Shapo.scan === 'function') window.Shapo.scan();
      } catch (e) {}
    }

    function open(fromPopstate) {
      var modal = getModal();
      if (!modal) return;
      moveToBody(modal);
      loadContent(modal);
      document.body.classList.add(BODY_CLASS);
      modal.style.setProperty('display', 'flex', 'important');
      modal.style.setProperty('visibility', 'visible', 'important');
      modal.style.setProperty('opacity', '1', 'important');
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('open');
      modal.dataset.historyPushed = modal.dataset.historyPushed || '0';

      if (!fromPopstate && modal.dataset.historyPushed !== '1') {
        try {
          history.pushState({ modal: 'avis' }, '', location.href);
        } catch (e) {}
        modal.dataset.historyPushed = '1';
      }
    }

    function close(fromPopstate) {
      var modal = getModal();
      if (!modal) return;
      document.body.classList.remove(BODY_CLASS);
      modal.style.setProperty('display', 'none', 'important');
      modal.style.setProperty('visibility', 'hidden', 'important');
      modal.style.setProperty('opacity', '0', 'important');
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('open');

      if (!fromPopstate && modal.dataset.historyPushed === '1') {
        modal.dataset.historyPushed = '0';
        try {
          history.back();
        } catch (e) {}
      } else if (fromPopstate) {
        modal.dataset.historyPushed = '0';
      }
    }

    return {
      getModal: getModal,
      isOpen: isOpen,
      open: open,
      close: close
    };
  })();








  function initPromoCountdown(root) {
    if (window.__idmCollectionPromoCountdownInit) return;

    var daysEl = document.getElementById('custom-promo-days-wrapper');
    var hrsEl = document.getElementById('custom-promo-hours');
    var minsEl = document.getElementById('custom-promo-minutes');
    var secsEl = document.getElementById('custom-promo-seconds');
    if (!daysEl || !hrsEl) return;

    if (!window.IDM_PROMO_COUNTDOWN || typeof window.IDM_PROMO_COUNTDOWN.getNextDeadline !== 'function') {
      return;
    }

    window.__idmCollectionPromoCountdownInit = true;

    var locale = window.IDM_PROMO_COUNTDOWN.getCurrentLocale();
    var countdownData = window.IDM_PROMO_COUNTDOWN.getNextDeadline(locale);
    var deadline = countdownData.deadlineMs;
    var isEN = countdownData.locale.indexOf('en') === 0;
    var prevDayLabel = null;

    function pad2(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function updateCountdown() {
      var diff = deadline - Date.now();
      if (diff <= 0) return window.location.reload();

      var d = Math.floor(diff / 86400000);
      var rem = diff % 86400000;
      var h = Math.floor(rem / 3600000);
      rem %= 3600000;
      var m = Math.floor(rem / 60000);
      rem %= 60000;
      var s = Math.floor(rem / 1000);

      var newDayLabel = d > 0
        ? d + (isEN ? (d === 1 ? ' day and ' : ' days and ') : (d === 1 ? ' jour et ' : ' jours et '))
        : '';

      if (newDayLabel !== prevDayLabel) {
        daysEl.textContent = newDayLabel;
        prevDayLabel = newDayLabel;
      }

      var hh = pad2(h);
      var mm = pad2(m);
      var ss = pad2(s);

      if (hrsEl.textContent !== hh) hrsEl.textContent = hh;
      if (minsEl && minsEl.textContent !== mm) minsEl.textContent = mm;
      if (secsEl && secsEl.textContent !== ss) secsEl.textContent = ss;
    }

    updateCountdown();

    if (window.__idmCollectionPromoCountdownTimer) {
      window.clearInterval(window.__idmCollectionPromoCountdownTimer);
    }

    window.__idmCollectionPromoCountdownTimer = window.setInterval(updateCountdown, 1000);
  }

  function initPromoMargins() {
  if (window.__idmCollectionPromoMarginsInit) return;

  var container = document.querySelector('.collection-items');
  if (!container) return;

  window.__idmCollectionPromoMarginsInit = true;

    var breakpoints = {
      mobileMax: 767,
      tabletMax: 1024,
      spanOverrideThreshold: 1000
    };

    function getItemsPerRow() {
      var w = window.innerWidth;
      if (w <= breakpoints.mobileMax) return 2;
      if (w <= breakpoints.tabletMax) return 3;
      return 4;
    }

    function adjustMargins() {
      var container = document.querySelector('.collection-items');
      if (!container) return;

      var itemsPerRow = getItemsPerRow();
      var gridSlot = 0;

      Array.prototype.forEach.call(container.children, function (el) {
        var span = (el.classList.contains('promo-item') && window.innerWidth > breakpoints.spanOverrideThreshold) ? 2 : 1;

        el.style.removeProperty('margin-left');

        if (gridSlot === 0) {
          el.style.setProperty('margin-left', '0', 'important');
        }

        gridSlot = (gridSlot + span) % itemsPerRow;
      });
    }

    adjustMargins();
    window.addEventListener('resize', adjustMargins);

    var container = document.querySelector('.collection-items');
    if (container && !container.__promoObserverAttached) {
      container.__promoObserverAttached = true;

      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i += 1) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length > 0) {
            adjustMargins();
            break;
          }
        }
      });

      observer.observe(container, { childList: true });
    }
  }

  function initCollectionScrollRestore() {
    if (window.__collectionScrollRestoreInstalled) return;
    window.__collectionScrollRestoreInstalled = true;

    var KEY = 'collection:state:' + location.pathname + location.search;
    var SNAP_KEY = 'collection:snap:' + location.pathname + location.search;
    var canManualScrollRestore = ('scrollRestoration' in history);
    var RESTORE_WINDOW_MS = 800;
    var NEAR_EPS = 4;
    var grid;
    var btn;
    var pagesLoaded = 0;

    function qs(sel) { return document.querySelector(sel); }
    function qsa(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }
    function countProducts() { return qsa('.collection-items .collection-item').length; }
    function getGrid() { return grid || (grid = qs('.collection-items')); }
    function getBtn() { return btn || (btn = qs('.collection-load-more')); }

    function saveState(extra) {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var anchor = (window.IDM_ScrollAnchor && window.IDM_ScrollAnchor.compute) ? window.IDM_ScrollAnchor.compute() : null;
      var baseState = { y: y, a: anchor, pages: pagesLoaded, t: Date.now() };
      var state = extra ? Object.assign({}, baseState, extra) : baseState;
      try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
    }

    function readState() {
      try {
        var raw = sessionStorage.getItem(KEY);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    }

    function clearStateSoon() {
      setTimeout(function () {
        try { sessionStorage.removeItem(KEY); } catch (e) {}
      }, 800);
    }

    function clearStateNow() {
      try { sessionStorage.removeItem(KEY); } catch (e) {}
    }

    function readSnap() {
      try {
        var raw = sessionStorage.getItem(SNAP_KEY);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    }

    function saveSnap() {
      var g = getGrid();
      if (!g) return;

      var compteur = document.getElementById('collection-items-counter');
      var bouton = getBtn();
      var filtres = [];
      $all('#filters-bar .filter-checkbox:checked').forEach(function (x) { if (x.id) filtres.push(x.id); });
      var prixMin = $('#filters-bar .sort-price-min');
      var prixMax = $('#filters-bar .sort-price-max');
      var chips = document.getElementById('collection-active-chips');

      var snap = {
        t: Date.now(),
        pages: pagesLoaded,
        html: g.innerHTML,
        nextUrl: g.getAttribute('data-next-url') || '',
        amount: g.getAttribute('data-amount') || '',
        compteur: compteur ? { from: compteur.dataset.from || '', to: compteur.dataset.to || '', total: compteur.dataset.total || '', texte: compteur.textContent } : null,
        bouton: bouton ? { href: bouton.getAttribute('href') || '', visible: getComputedStyle(bouton).display !== 'none' } : null,
        filtres: filtres,
        prixMin: prixMin ? prixMin.value : '',
        prixMax: prixMax ? prixMax.value : '',
        chips: chips ? chips.innerHTML : null
      };

      // 01/11/2026 — colonne de filtres (test A/B, snippets/idm-filtres-colonne.liquid) : les compteurs, les valeurs masquées et le nombre de produits sont visibles :
      // ils reviennent aussi au retour arrière. Hors colonne : rien de plus dans la mémoire.
      if (window.IDM_FCOL && window.IDM_FCOL.actif()) {
        var nb = $('#filters-bar .idm-fcol-nb');
        snap.nb = nb ? nb.textContent : '';
        snap.valeurs = [];
        $all('#filters-bar .filter-checkbox').forEach(function (x) {
          var lab = x.closest('label'), c = lab ? lab.querySelector('.filter-option-count') : null;
          if (x.id && lab) snap.valeurs.push([x.id, c ? c.textContent : '', lab.classList.contains('filter-option-disabled') ? 1 : 0]);
        });
      }

      try { sessionStorage.setItem(SNAP_KEY, JSON.stringify(snap)); } catch (e) {}
    }

    function restaurerEtatAutourGrille(snap) {
      var bouton = getBtn();
      if (bouton && snap.bouton) {
        if (snap.bouton.href) bouton.setAttribute('href', snap.bouton.href);
        else bouton.removeAttribute('href');
        bouton.style.display = snap.bouton.visible ? 'block' : 'none';
      }
      var compteur = document.getElementById('collection-items-counter');
      if (compteur && snap.compteur) {
        compteur.dataset.from = snap.compteur.from;
        compteur.dataset.to = snap.compteur.to;
        compteur.dataset.total = snap.compteur.total;
        compteur.textContent = snap.compteur.texte;
      }
      if (Array.isArray(snap.filtres)) {
        $all('#filters-bar .filter-checkbox').forEach(function (x) { x.checked = snap.filtres.indexOf(x.id) !== -1; });
        var prixMin = $('#filters-bar .sort-price-min');
        var prixMax = $('#filters-bar .sort-price-max');
        if (prixMin) prixMin.value = snap.prixMin || '';
        if (prixMax) prixMax.value = snap.prixMax || '';
        var chips = document.getElementById('collection-active-chips');
        if (chips && typeof snap.chips === 'string') chips.innerHTML = snap.chips;
        if (Array.isArray(snap.valeurs)) {
          var nb = $('#filters-bar .idm-fcol-nb');
          if (nb && snap.nb && nb.textContent !== snap.nb) nb.textContent = snap.nb;
          snap.valeurs.forEach(function (v) {
            var x = document.getElementById(v[0]), lab = x ? x.closest('label') : null;
            if (!lab) return;
            var c = lab.querySelector('.filter-option-count'), off = !!v[2];
            if (c && c.textContent !== v[1]) c.textContent = v[1];
            if (x.disabled !== off) x.disabled = off;
            if (lab.classList.contains('filter-option-disabled') !== off) lab.classList.toggle('filter-option-disabled', off);
          });
        }
        var synchro = function () { if (typeof window.IDM_syncFiltresUI === 'function') window.IDM_syncFiltresUI(); };
        synchro();
        setTimeout(synchro, 0);
        window.addEventListener('load', synchro, { once: true });
      }
    }

    function clearSnap() {
      try { sessionStorage.removeItem(SNAP_KEY); } catch (e) {}
    }

    // 02/11/2026 — retour arrière sans décalage (voir l'appel, plus bas) : tout ce qui suit la grille, à chaque niveau jusqu'à <body>, est
    // rendu invisible (visibility, la place reste la même) ; réapparition à l'image qui suit celle de la remise en place (deux images :
    // la première est peinte avec ces blocs invisibles), au plus tard 1,5 s après. Rien n'est écrit si le bloc est déjà invisible.
    // Rend la fonction de réapparition, avec siRienNaBouge() : tout réapparaît tout de suite si le 1er bloc caché est resté à la même place
    // dans la page (grille de même hauteur : rien n'arrive de loin dans l'écran, l'image sans ces blocs n'est jamais peinte).
    function masquerSousGrille(grille) {
      var masques = [];
      var ref = null, y0 = 0;
      var cacher = function (el) {
        if (!el || el.nodeType !== 1) return;
        var tag = el.tagName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'LINK' || tag === 'TEMPLATE' || tag === 'NOSCRIPT') return;
        var cs = getComputedStyle(el);
        if (cs.position === 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return;
        if (!ref) { ref = el; y0 = el.getBoundingClientRect().top + (window.pageYOffset || 0); }
        masques.push([el, el.style.visibility]);
        el.style.visibility = 'hidden';
      };
      try {
        var n = grille;
        while (n && n !== document.body && n !== document.documentElement) {
          var frere = n.nextElementSibling;
          while (frere) { cacher(frere); frere = frere.nextElementSibling; }
          n = n.parentElement;
        }
      } catch (e) {}
      var fait = false;
      var reveler = function () {
        if (fait) return;
        fait = true;
        for (var i = 0; i < masques.length; i += 1) masques[i][0].style.visibility = masques[i][1];
        masques.length = 0;
      };
      reveler.siRienNaBouge = function () {
        try { if (ref && Math.abs(ref.getBoundingClientRect().top + (window.pageYOffset || 0) - y0) < 1) reveler(); } catch (e) { reveler(); }
      };
      if (!masques.length) return reveler;
      try { requestAnimationFrame(function () { requestAnimationFrame(reveler); }); } catch (e) { reveler(); }
      setTimeout(reveler, 1500);
      return reveler;
    }

    function hasPromoHash() {
      return !!(location.hash && /^#promo/i.test(location.hash));
    }

    function stripPromoHash() {
      if (hasPromoHash()) {
        try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
      }
    }

    function lockScroll(maxMs) {
      var root = document.documentElement;
      var body = document.body;
      var prev = {
        overflow: root.style.overflow,
        scrollBehavior: root.style.scrollBehavior,
        pe: body.style.pointerEvents,
        ta: body.style.touchAction
      };

      root.style.overflow = 'hidden';
      root.style.scrollBehavior = 'auto';
      body.style.pointerEvents = 'none';
      body.style.touchAction = 'none';

      var timer = setTimeout(unlock, Math.max(300, maxMs || 1000));

      function unlock() {
        clearTimeout(timer);
        root.style.overflow = prev.overflow || '';
        root.style.scrollBehavior = prev.scrollBehavior || '';
        body.style.pointerEvents = prev.pe || '';
        body.style.touchAction = prev.ta || '';
      }

      return { unlock: unlock };
    }

    function makeRestoreJob(targetY) {
      var cancelled = false;
      var finished = false;
      var start = Date.now();
      var t1 = null;
      var onUser;

      function cleanup() {
        if (t1) {
          clearTimeout(t1);
          t1 = null;
        }
        window.removeEventListener('scroll', onUser, { passive: true });
        window.removeEventListener('wheel', onUser, { passive: true });
        window.removeEventListener('touchstart', onUser, { passive: true });
        window.removeEventListener('keydown', onUser, { passive: true });
      }

      function cancel() {
        if (finished || cancelled) return;
        cancelled = true;
        cleanup();
      }

      function done() {
        if (finished) return;
        finished = true;
        cleanup();
      }

      function stillOk() {
        if (cancelled || finished) return false;
        if (Date.now() - start > RESTORE_WINDOW_MS) {
          cancel();
          return false;
        }
        return true;
      }

      onUser = function () {
        cancel();
      };

      window.addEventListener('scroll', onUser, { passive: true });
      window.addEventListener('wheel', onUser, { passive: true });
      window.addEventListener('touchstart', onUser, { passive: true });
      window.addEventListener('keydown', onUser, { passive: true });

      return {
        go: function () {
          if (!stillOk()) return;
          var ty = (typeof targetY === 'function') ? targetY() : targetY;
          if (ty === null || ty === undefined) { cancel(); return; }
          var cur = window.pageYOffset || document.documentElement.scrollTop || 0;
          if (Math.abs(cur - ty) <= NEAR_EPS) {
            done();
            return;
          }
          window.scrollTo(0, ty);
        },
        raf: function () {
          if (!stillOk()) return;
          requestAnimationFrame(this.go);
        },
        later: function (ms) {
          if (!stillOk()) return;
          t1 = setTimeout(this.go, ms);
        },
        onLoadOnce: function () {
          if (!stillOk()) return;
          window.addEventListener('load', this.go, { once: true });
        },
        onLazyOnce: function () {
          if (!stillOk()) return;
          document.addEventListener('lazyloaded', this.go, { once: true });
        },
        done: done,
        cancel: cancel
      };
    }

    function waitForAppend(prevCount, timeoutMs) {
      return new Promise(function (resolve) {
        var gridEl = getGrid();
        if (!gridEl) return resolve(false);

        var done = false;
        var obs;
        var to = setTimeout(function () {
          if (!done) {
            done = true;
            if (obs) obs.disconnect();
            resolve(false);
          }
        }, timeoutMs || 6000);

        obs = new MutationObserver(function () {
          if (done) return;
          var now = countProducts();
          if (now > prevCount) {
            done = true;
            clearTimeout(to);
            obs.disconnect();
            resolve(true);
          }
        });

        obs.observe(gridEl, { childList: true, subtree: true });
      });
    }

    function replayLoadMore(times) {
      var b = getBtn();
      if (!b || b.style.display === 'none') return Promise.resolve();

      var sequence = Promise.resolve();

      for (var i = 0; i < times; i += 1) {
        sequence = sequence.then(function () {
          var before = countProducts();
          if (!b || b.style.display === 'none') return false;
          b.click();
          return waitForAppend(before, 10000);
        }).then(function (ok) {
          if (!ok) throw new Error('append-timeout');
        });
      }

      return sequence.catch(function () {});
    }

    document.addEventListener('DOMContentLoaded', function () {
      var b = getBtn();
      if (!b) return;

      b.addEventListener('click', function () {
        saveState();
        var before = countProducts();
        waitForAppend(before, 10000).then(function (ok) {
          if (ok) {
            pagesLoaded += 1;
            saveState();
          }
        });
      }, true);
    });

    document.addEventListener('DOMContentLoaded', function () {
      document.body.addEventListener('click', function (ev) {
        var link = ev.target.closest('.collection-items a[href*="/products/"]');
        if (!link) return;
        if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || link.target === '_blank') return;

        if (canManualScrollRestore) history.scrollRestoration = 'manual';
        saveState({ intent: 'product' });
        saveSnap();
      }, true);

      // 02/11/2026 — fiche ouverte par « Voir le produit » de la fenêtre vidéo d'une carte (snippets/popup-videos.liquid, depuis le 23/10) :
      // même mémoire que le toucher d'une carte (position, grille avec les pages de « Voir plus »). Avant, rien n'était gardé : au retour, la
      // page revenait à l'endroit du dernier « Voir plus » (relevé au banc : 23 528 px au lieu de 17 774) ou en haut sans « Voir plus ».
      // La fenêtre est ouverte (fond figé par overflow:hidden : la position lue est la bonne) ; elle retire ensuite son étape d'historique
      // (history.back) avant d'ouvrir la fiche : le mode 'manual' est reposé sur l'entrée de la collection à ce retour (popstate).
      document.addEventListener('click', function (ev) {
        var voir = ev.target && ev.target.closest ? ev.target.closest('.modal-video .idm-video-voir') : null;
        if (!voir) return;
        if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
        if ((voir.getAttribute('href') || '').indexOf('/products/') === -1) return;
        saveState({ intent: 'product' });
        saveSnap();
        if (!canManualScrollRestore) return;
        history.scrollRestoration = 'manual';
        var surRetour = function () { try { history.scrollRestoration = 'manual'; } catch (e) {} };
        window.addEventListener('popstate', surRetour, { once: true });
        setTimeout(function () { window.removeEventListener('popstate', surRetour); }, 1500);
      }, true);
    });

    document.addEventListener('DOMContentLoaded', function () {
      var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || null;
      var isBackForward = !!(nav && nav.type === 'back_forward');

      if (!isBackForward) {
        clearStateNow();
        clearSnap();
        if (canManualScrollRestore) history.scrollRestoration = 'auto';
        return;
      }

      var state = readState();
      var snap = readSnap();
      if (!state && !snap) return;

      if (canManualScrollRestore) history.scrollRestoration = 'manual';
      if (hasPromoHash()) stripPromoHash();

      var didInstant = false;

      try {
        if (snap && snap.html) {
          var g = getGrid();
          if (g) {
            // 02/11/2026 — retour arrière SANS décalage (contrôle du lundi : /collections/tongue-drum 0,381, bol-tibetain 0,326, handpan 0,354 ;
            // reproduit au banc : 0,1235 à chaque retour vers le bas d'une grille allongée par « Voir plus »). La remise en place ne change pas.
            // Cause : ce qui suit la grille (bouton « Voir plus », sections sous la grille, pied de page) était déjà affiché à sa place de la
            // page 1 ; dans la MÊME image, la grille reprend toutes les pages chargées et la position est remise : ces blocs arrivent dans l'écran
            // très loin de leur place d'avant, et Chrome compte ce déplacement. Ils sont rendus invisibles le temps de cette image (un élément
            // invisible qui réapparaît ailleurs n'est pas un décalage : même principe que « Voir plus », snippets/popup-filters.liquid), puis
            // réapparaissent à leur place à l'image suivante. Les éléments fixes (panier, chat, cookies) ne sont pas touchés. Grille de même
            // hauteur (pas de « Voir plus ») : rien ne bouge, tout réapparaît tout de suite (aucune image sans ces blocs).
            var revelerSousGrille = masquerSousGrille(g);
            g.innerHTML = snap.html;
            g.setAttribute('data-next-url', snap.nextUrl || '');
            if (snap.amount) g.setAttribute('data-amount', snap.amount);
            pagesLoaded = snap.pages || 0;
            restaurerEtatAutourGrille(snap);
            revelerSousGrille.siRienNaBouge();
            try { window.dispatchEvent(new Event('resize')); } catch (e) {}
            try { if (window.lazySizes && lazySizes.loader) lazySizes.loader.checkElems(); } catch (e) {}
            didInstant = true;
          }
        }
      } catch (e) {}

      var y = state && Number.isFinite(state.y) ? state.y : 0;
      var resolveTY = function () {
        if (window.IDM_ScrollAnchor && state && state.a) {
          var el = window.IDM_ScrollAnchor.find(state.a);
          if (el) return window.IDM_ScrollAnchor.targetY(state.a, el);
        }
        return y;
      };
      if (y > 0 || (state && state.a)) {
        var maxLockMs = didInstant ? 300 : Math.min(1200 + 900 * (state.pages || 0), 4000);
        var locker = lockScroll(maxLockMs);

        Promise.resolve()
          .then(function () {
            if (!didInstant && state && Number.isFinite(state.pages) && state.pages > 0) {
              return replayLoadMore(state.pages);
            }
          })
          .finally(function () {
            var job = makeRestoreJob(resolveTY);
            job.go();
            job.raf();
            job.onLoadOnce();
            job.onLazyOnce();
            job.later(40);

            setTimeout(function () {
              var cur = window.pageYOffset || document.documentElement.scrollTop || 0;
              var ty = resolveTY();
              if (Math.abs(cur - ty) <= NEAR_EPS) job.done();
            }, 90);

            locker.unlock();
            setTimeout(function () {
              if (canManualScrollRestore) history.scrollRestoration = 'auto';
            }, RESTORE_WINDOW_MS + 50);
          });
      }

      clearStateSoon();
    });
  }

  function bootRoot(root) {
    if (!root) return;

    initStickyHeader(root);
    initPromoCountdown(root);
    initPromoMargins();

    if ($('.product-size-guide', root) || $(TEXT_MODAL_SEL)) {
      TextModal.boot();
    }

    if ($('.product-size-guide2', root) || $(VIDEO_MODAL_SEL)) {
      VideoModal.boot();
    }

    if (window.__markProductModalsReady) {
      window.__markProductModalsReady();
    }
  }

  function bootAllRoots() {
    $all(ROOT_SELECTOR).forEach(bootRoot);
  }

  function initCartesReflet() {
    if (window.__idmCartesRefletInit) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.__idmCartesRefletInit = true;

    function briller(carte) {
      if (!carte || carte.__idmBrille) return;
      carte.__idmBrille = true;
      carte.classList.add('idm-carte--brille');
      setTimeout(function () {
        carte.classList.remove('idm-carte--brille');
        carte.__idmBrille = false;
      }, 2400);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        briller(entry.target);
      });
    }, { threshold: 0.6 });

    function suivre(scope) {
      $all('.idm-carte', scope).forEach(function (carte) {
        if (carte.__idmRefletSuivi) return;
        carte.__idmRefletSuivi = true;
        io.observe(carte);
      });
    }

    function survol(event) {
      var carte = event.target && event.target.closest ? event.target.closest('.idm-carte') : null;
      if (!carte) return;
      if (event.relatedTarget && carte.contains(event.relatedTarget)) return;
      briller(carte);
    }

    suivre(document);
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      document.addEventListener('mouseover', survol);
    }
    document.addEventListener('focusin', survol);

    if ('MutationObserver' in window) {
      $all('.collection-items').forEach(function (grille) {
        new MutationObserver(function () {
          suivre(grille);
        }).observe(grille, { childList: true });
      });
    }
  }

  function initGlobalHandlers() {
    if (window.__idmCollectionGlobalHandlersInit) return;
    window.__idmCollectionGlobalHandlersInit = true;

    initCollectionScrollRestore();
    initCartesReflet();

    document.body.addEventListener('click', function (event) {
      var target = event.target;
      var button;
      var root;
      var modal;

      button = target.closest('.collection-description-button');
      if (button) {
        root = getRoot(button) || getPrimaryRoot();
        toggleReadMore(button, root);
        return;
      }

      button = target.closest('.collection-description-mobile-toggle');
      if (button) {
        event.preventDefault();

        var blockId = button.getAttribute('data-description-block');
        var blockEl = blockId ? document.getElementById(blockId) : null;
        var targetId = button.getAttribute('data-description-target');
        var targetEl = targetId ? document.getElementById(targetId) : null;

        root = getRoot(button) || getPrimaryRoot();
        var readMore = root ? (root.getAttribute('data-read-more-label') || '') : '';
        var readLess = root ? (root.getAttribute('data-read-less-label') || '') : '';

        if (blockEl && targetEl) {
          var alreadyExpanded = blockEl.classList.contains('is-expanded');

          if (!alreadyExpanded) {
            blockEl.classList.add('is-expanded');
            button.textContent = readLess;
            targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            blockEl.classList.remove('is-expanded');
            button.textContent = readMore;
          }

          return;
        }

        if (targetEl) {
          targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }

        if (blockEl) {
          var expanded = blockEl.classList.toggle('is-expanded');
          button.textContent = expanded ? readLess : readMore;
        }

        return;
      }

      button = target.closest('.idm-avis-open, .idm-carte--avis');
      if (button) {
        event.preventDefault();
        AvisModal.open(false);
        return;
      }

      button = target.closest('.idm-avis-close');
      if (button) {
        event.preventDefault();
        AvisModal.close(false);
        return;
      }

      modal = AvisModal.getModal();
      if (modal && target === modal) {
        AvisModal.close(false);
        return;
      }

      button = target.closest('.product-size-guide');
      if (button) {
        event.preventDefault();
        modal = TextModal.ensure();
        TextModal.open(modal, false);
        return;
      }

      button = target.closest('#close-sizechart-bar');
      if (button) {
        modal = button.closest(TEXT_MODAL_SEL) || TextModal.ensure();
        TextModal.close(modal, false);
        return;
      }

      if (target.matches(TEXT_MODAL_SEL)) {
        TextModal.close(target, false);
        return;
      }

      button = target.closest('.product-size-guide2');
      if (button) {
        event.preventDefault();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        event.stopPropagation();

        VideoModal.open(true);
        return;
      }

      button = target.closest('#close-sizechart-bar2');
      if (button) {
        event.preventDefault();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        event.stopPropagation();

        VideoModal.close(true);
        return;
      }

      modal = VideoModal.getModal();
      if (modal && target === modal) {
        event.preventDefault();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        event.stopPropagation();

        VideoModal.close(true);
        return;
      }
    }, true);

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && AvisModal.isOpen()) {
        AvisModal.close(false);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      var ouverte = TextModal.getOpen();
      if (ouverte) TextModal.close(ouverte, false);
    });

    window.addEventListener('popstate', function (e) {
  if (VideoModal.isOpen()) {
    VideoModal.close(false, true);
    return;
  }

  if (AvisModal.isOpen()) {
    AvisModal.close(true);
    return;
  }

  var openText = TextModal.getOpen();
  if (openText) {
    TextModal.close(openText, true);
    return;
  }

  if (e && e.state && e.state.modal === 'avis') {
    AvisModal.open(true);
    return;
  }

  if (e && e.state && e.state.modal === 'text') {
    var modal = TextModal.ensure();
    if (modal) TextModal.open(modal, true);
  }
});
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    initGlobalHandlers();
    bootAllRoots();
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;

    if (section.matches && section.matches(ROOT_SELECTOR)) {
      bootRoot(section);
      return;
    }

    var nestedRoot = section.querySelector ? section.querySelector(ROOT_SELECTOR) : null;
    if (nestedRoot) {
      bootRoot(nestedRoot);
    }
  });
})();